import React, { useState, useEffect } from 'react'
import Classes from './Dashboard.module.css'
import Hero1 from './Comp/Hero1';
import RecordTable from './Comp/RecordTable/RecordTable';
import Hero2 from './Comp/Hero2/Hero2';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import backend from '../../../../../api';
import RateExperiencePopup from '../../../../GlobalComponents/RateExperiencePopup/RateExperiencePopup';
import { AnimatePresence } from 'framer-motion';
import WarningStrip from './Comp/WarningStrip';

export default function Dashboard() {
  const navigateTo = useNavigate();

  const { user } = useSelector((state) => state.auth);
  const userId = user?._id;
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [showWarning, setShowWarning] = useState(true);

  const [openRateExpPopup, setopenRateExpPopup] = useState(false);
  const handleOpenRateExpPopup = () => {
    setopenRateExpPopup(true);
  }
  const handleCloserateExpPopup = () => {
    setopenRateExpPopup(false);
  }

  async function GetBookings() {
    try {
      const response = await backend.get(`/bookings/mentee?userId=${userId}`);
      setBookings(response.data);
      setLoading(false);
    } catch (err) {
      console.error("Error fetching bookings:", err);
      setError(err.response?.data?.error || "Failed to load bookings");
      setLoading(false);
    }
  }

  console.log(user)

  useEffect(() => {
    if (userId && user.role === "mentee") {
      GetBookings();
    } else {
      setError("Only mentees can access this dashboard");
      setLoading(false);
    }
  }, [userId, user.role]);

  return (
    <>
      <div className={Classes.hero} >
        {showWarning && <WarningStrip handleCloseWarning={() => setShowWarning(false)} />}

        <Hero1 bookings={bookings} />
        <Hero2 bookings={bookings} />

        <div className='title' >
          <div>
            <h4 onClick={handleOpenRateExpPopup} >Upcoming Meetings</h4>
            <h5 onClick={() => { navigateTo('/meetings') }} className='pointer' >View all</h5>
          </div>
          <hr />
        </div>
        <RecordTable bookings={bookings} loading={loading} />
      </div>
      <AnimatePresence mode='wait'>
        {openRateExpPopup && <RateExperiencePopup handleClose={handleCloserateExpPopup} />}
      </AnimatePresence>
    </>
  )
}
